export default __webpack_public_path__ + "static/media/leg-icon-avail.bd9a7619.png";